module.exports = __webpack_public_path__ + "static/badge-green-foam-28181bf8cadeb6424fa2f8d6b929a99c.png";